import {IDataGraphhopper} from "@containers/graphhopper/types";

export const normalizeGraphhopperFormat = (data: IDataGraphhopper): IDataGraphhopper => {
    return {
        ...data,
        paths: data?.paths?.map((pathItem) => {
            return {
                ...pathItem,
                points: {
                    ...(pathItem?.points),
                    coordinates: pathItem?.points?.coordinates.map(([lng, lat]) => [lat, lng])

                }
            }
        })
    }
}